/**
 * URL личного кабинета SMS (редирект «назад» из конструктора).
 * В проде задаётся в рантайме: GET /runtime-config.js (SMS_CABINET_URL на бэкенде).
 * Локально: REACT_APP_SMS_CABINET_URL или дефолт dev.
 */
declare global {
  interface Window {
    __SMS_CABINET_URL__?: string;
    __CASCADE_URL__?: string;
  }
}

export function getSmsCabinetUrl(): string | null {
  const fromRuntime =
    typeof window !== 'undefined' && window.__SMS_CABINET_URL__ !== undefined
      ? String(window.__SMS_CABINET_URL__)
      : '';
  const raw = (
    fromRuntime ||
    process.env.REACT_APP_SMS_CABINET_URL ||
    'https://app-sms.dev.progmateq.com'
  ).trim();
  if (!raw || raw === '0' || raw === 'false') return null;
  const withProto = raw.includes('://') ? raw : `https://${raw}`;
  try {
    const u = new URL(withProto);
    if (!u.protocol.startsWith('http')) return null;
    return u.toString().replace(/\/$/, '');
  } catch {
    return null;
  }
}

/** Абсолютная ссылка в личный кабинет SMS (меню сайдбара и т.п.). */
export function getSmsCabinetLink(path: string): string {
  const base = getSmsCabinetUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (!base) return normalized;
  return `${base}${normalized}`;
}

export function getSmsCabinetHost(): string {
  const base = getSmsCabinetUrl();
  if (!base) return 'app.sms.by';
  try {
    return new URL(base).hostname;
  } catch {
    return 'app.sms.by';
  }
}

export function getCascadeUrl(): string | null {
  const fromRuntime =
    typeof window !== 'undefined' && window.__CASCADE_URL__ !== undefined
      ? String(window.__CASCADE_URL__)
      : '';
  const raw = (fromRuntime || process.env.REACT_APP_CASCADE_URL || 'https://cascade.sms.by').trim();
  if (!raw || raw === '0' || raw === 'false') return null;
  const withProto = raw.includes('://') ? raw : `https://${raw}`;
  try {
    const u = new URL(withProto);
    if (!u.protocol.startsWith('http')) return null;
    return u.toString().replace(/\/$/, '');
  } catch {
    return null;
  }
}

function getStoredAuthToken(): string | null {
  try {
    return localStorage.getItem('bc_auth_token');
  } catch {
    return null;
  }
}

/** Открыть конструктор каскадов (POST set-auth), как в sms/app/frontend. */
export function openCascadeConstructor(userId: string | number): void {
  const base = getCascadeUrl();
  if (!base) return;
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${base}/api/set-auth`;
  form.style.display = 'none';

  const userIdInput = document.createElement('input');
  userIdInput.type = 'hidden';
  userIdInput.name = 'user_id';
  userIdInput.value = String(userId);

  const hostInput = document.createElement('input');
  hostInput.type = 'hidden';
  hostInput.name = 'host';
  hostInput.value = getSmsCabinetHost();

  form.appendChild(userIdInput);
  form.appendChild(hostInput);

  const token = getStoredAuthToken();
  if (token) {
    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'token';
    tokenInput.value = token;
    form.appendChild(tokenInput);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
